import React, { useState } from "reactn";
import { Formik, Form, Field } from 'formik';
import GoogleMaps from '../googleMaps'
import axios from 'axios';


function validateEmail(value) {
  let error;
  if (!value) {
    error = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = 'Invalid email address';
  }
  return error;
}

function validateUsername(value) {
  let error;
  if (value === '') {
    error = 'Please enter a name';
  }
  return error;
}
function validateMessage(value) {
  let error;
  if (value === '') {
    error = 'Please enter a message';
  }
  return error;
}

const Contact = () => {

const [userMessage, setUserMessage] = useState('');
const [buttonDiv, setButtonDiv] = useState('');



return (
  <div>
    <div className="home-page">
        <div className="row">
          <div className="col-12">
            <div className="intro-text">
              <p>Drop me a line at <a href="mailTo:hello@design-mind.co.uk">hello@design-mind.co.uk</a></p>
            </div>
          </div>
        </div>
        <div className="row">

        <div className="col-12 col-md-6">
          <GoogleMaps />
        </div>
        <div className="col-12 col-md-6">
        <div class="d-flex justify-content-end">
        

          <Formik
              initialValues={{
                name: '',
                email: '',
                message: ''
              }}

            //   'design/v1/latest-posts'
              onSubmit={values => {
                setButtonDiv('hide');
                setUserMessage('submitting form please wait...')
                axios.post(`http://design-mind.co.uk/design-admin//wp-json/design/v1/latest-posts`, values )
                .then(res => {
                    if(res.data === 'success') {
                        setUserMessage('thanks for the message we will be in contact shortly')
                        setButtonDiv('');
                    } else {
                        setUserMessage('sorry there was a problem please send me an email to the address at the top of the page')
                        setButtonDiv('');
                    }
                    
                })
              }}
            >
              {({ errors, touched, isValidating }) => (
                <Form className="">
                  <div className="input-area">
                    <label className="">Name</label>
                    <div className="input-area-box">
                      <Field name="name" validate={validateUsername} />
                      {errors.name && touched.name && <div>{errors.name}</div>}
                    </div>
                  </div>
                  <div className="input-area">
                    <label className="">Email address*</label>
                    <div className="input-area-box">
                      <Field name="email" validate={validateEmail} />
                      {errors.email && touched.email && <div>{errors.email}</div>}
                    </div>
                  </div>
                  <div className="input-area">
                    <label className="message-label">Message</label>
                    <div className="input-area-box">
                      <Field component="textarea" validate={validateMessage} className="form-text-area" name="message" />
                      {errors.message && touched.message && <div>{errors.message}</div>}
                    </div>
                  </div>
                  <div className="input-area" id={buttonDiv}>
                    <label className="message-label"></label>
                    <div className="input-area-box">
                      <button type="submit" className="submit-button">Submit</button>
                    </div>
                  </div>
                  <div className="input-area">
                  <label className="message-label"></label>
                  <div className="input-area-box">
                    <p>{ userMessage }</p>
                  </div>
                    
                    
                  </div>
                  
                </Form>
              )}
            </Formik>
            
            </div>
          </div>
          </div>        
        
    </div>
    
  </div>
)  
};

export default Contact;
